import Vue from 'vue';
import vSelect from 'vue-select';
import Footer from '@/layouts/Footer';
import NavBar from '@/layouts/NavBar';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';

Vue.component('v-select', vSelect);
Vue.component('NavBar', NavBar);
Vue.component('Footer', Footer);
Vue.component('LanguageSwitcher', LanguageSwitcher);
